// eslint-disable-next-line no-restricted-imports
import type { NextPage } from 'next';
import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import React, { useEffect } from 'react';

import { installChunkLoadReload } from '@webapp/common/lib/chunk-error';

import { SurveyPageWrap } from '@webapp/survey/src/components/pages';

import '@webapp/common/assets/styles/fonts.css';

const NoSSR = dynamic(() => import('./new-app'), { ssr: false });

if (typeof window !== 'undefined') {
    // Ссылка на опрос иногда приходит с задвоенным слэшем в пути (https://host//?alias=...):
    // Next ругается «Invalid href '//' passed to next/router», а кривой URL ломает роутинг.
    // Схлопываем повторы до инициализации приложения.
    const { pathname, search, hash } = window.location;
    const normalizedPath = pathname.replace(/\/{2,}/g, '/');

    if (normalizedPath !== pathname) {
        window.history.replaceState(null, '', `${normalizedPath}${search}${hash}`);
    }

    window.React = React;
    installChunkLoadReload();
}

// eslint-disable-next-line import/no-default-export
// export { SurveyPageWrap as default };

export const SurveyNewApp: NextPage<AppProps> = ({ ...props }) => {
    const redirectUrl = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('redirect_to');

    useEffect(() => {
        if (!redirectUrl) return;

        let target: URL;

        try {
            target = new URL(redirectUrl, window.location.href);
        } catch (e) {
            return;
        }

        // Навигация на тот же URL роняет Next.js (Invariant: attempted to hard navigate to the same URL)
        if (target.href === window.location.href) return;

        window.location.replace(target.href);
    }, [redirectUrl]);

    return <NoSSR {...props} Component={SurveyPageWrap} />;
};

export default SurveyNewApp;
